import { render } from "./MembershipTrigger.vue?vue&type=template&id=a6240c70"
import script from "./MembershipTrigger.vue?vue&type=script&lang=js"
export * from "./MembershipTrigger.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zvonkobiskup/Code/op3/wp-content/plugins/op-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__